var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"headerlayout"}),_vm._t("content",function(){return [_c('v-content',[_c('v-container',{staticClass:"content-box",staticStyle:{"padding-bottom":"260px"},attrs:{"fluid":""}},[_c('router-view')],1)],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }